import { Skeleton } from "@organizacaox/lai-design-system";

export function ConnectionsSkeleton() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className="w-full min-w-0 motion-reduce:[&_[data-slot=skeleton]]:animate-none"
    >
      <span className="sr-only">Carregando conexões…</span>
      <div aria-hidden="true" className="divide-y rounded-xl border px-4">
        {["w-44", "w-32"].map((width) => (
          <div key={width} className="flex min-w-0 flex-col gap-3 py-4">
            <Skeleton className={`h-4 max-w-full ${width}`} />
            <Skeleton className="h-3.5 w-full max-w-sm" />
            <div className="flex items-center gap-2">
              <Skeleton variant="circle" className="size-2 shrink-0" />
              <Skeleton className="h-3 w-36 max-w-full" />
            </div>
            <Skeleton className="h-3 w-24" />
          </div>
        ))}
      </div>
    </div>
  );
}
